import ContentLoader from "react-content-loader";

const RichEditorSkeleton = () => {
  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={500}
      viewBox="0 0 1000 500"
      backgroundColor="#e7cece"
      foregroundColor="#ebeceb"
    >
      {/* ── Page Title ── */}
      <rect x="20" y="10" rx="6" ry="6" width="300" height="10" />

      {/* ── Card Header ── */}
      <rect x="20" y="30" rx="10" ry="10" width="960" height="30" />

      {/* ── Editor 1 Toolbar ── */}
      <rect x="40" y="80" rx="6" ry="6" width="50" height="20" />
      <rect x="100" y="80" rx="6" ry="6" width="50" height="20" />
      <rect x="160" y="80" rx="6" ry="6" width="50" height="20" />
      <rect x="220" y="80" rx="6" ry="6" width="50" height="20" />
      <rect x="280" y="80" rx="6" ry="6" width="50" height="20" />
      <rect x="340" y="80" rx="6" ry="6" width="80" height="20" />

      {/* ── Editor 1 Area ── */}
      <rect x="20" y="110" rx="12" ry="12" width="960" height="90" />

      {/* ── Editor 2 Toolbar ── */}
      <rect x="40" y="220" rx="6" ry="6" width="50" height="20" />
      <rect x="100" y="220" rx="6" ry="6" width="50" height="20" />
      <rect x="160" y="220" rx="6" ry="6" width="50" height="20" />
      <rect x="220" y="220" rx="6" ry="6" width="50" height="20" />
      <rect x="280" y="220" rx="6" ry="6" width="50" height="20" />
      <rect x="340" y="220" rx="6" ry="6" width="80" height="20" />

      {/* ── Editor 2 Area ── */}
      <rect x="20" y="250" rx="12" ry="12" width="960" height="90" />

      {/* ── Bottom Buttons (NOW VISIBLE) ── */}
      <rect x="720" y="360" rx="8" ry="8" width="120" height="40" />
      <rect x="860" y="360" rx="8" ry="8" width="120" height="40" />
    </ContentLoader>
  );
};

export default RichEditorSkeleton;
